var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('section',{attrs:{"id":"editContent"}},[_c('h1',{staticClass:"contentTitle"},[_vm._v("캐스트잇 관리자 설정")]),_c('Category')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }